import React, { useEffect, useState, useRef } from 'react';
export function CountdownTimer() {
  const [display, setDisplay] = useState('15:00');
  const timeRef = useRef(15 * 60);
  const timerRef = useRef<ReturnType<typeof setInterval> | null>(null);
  const rafRef = useRef<number>(0);
  useEffect(() => {
    rafRef.current = requestAnimationFrame(() => {
      timerRef.current = setInterval(() => {
        timeRef.current -= 1;
        if (timeRef.current <= 0) {
          timeRef.current = 0;
          if (timerRef.current) clearInterval(timerRef.current);
        }
        const m = Math.floor(timeRef.current / 60);
        const s = timeRef.current % 60;
        setDisplay(`${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`);
      }, 1000);
    });
    return () => {
      cancelAnimationFrame(rafRef.current);
      if (timerRef.current) clearInterval(timerRef.current);
    };
  }, []);
  return <div className="fixed top-0 left-0 right-0 z-50 bg-gradient-to-r from-[var(--accent-orange)] to-[var(--accent-orange-hover)] shadow-lg" style={{
    contain: 'layout style'
  }} data-id="element-84">
      <div className="max-w-7xl mx-auto px-4 py-3 md:py-4" data-id="element-85">
        <div className="flex items-center justify-center gap-3 md:gap-4" data-id="element-86">
          <div className="flex items-center gap-2 md:gap-3" data-id="element-87">
            <span className="text-white text-base md:text-lg lg:text-xl font-bold" data-id="element-88">
              Oferta Especial por hoy 🤍
            </span>
            <div className="flex items-center gap-1 md:gap-2 bg-white/20 px-3 py-1.5 md:px-4 md:py-2 rounded-lg" data-id="element-89">
              <span className="text-white font-black text-lg md:text-2xl tabular-nums" data-id="element-90">
                {display}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>;
}